module.exports = __webpack_public_path__ + "img/PE.ac37e726.svg";